import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { getInvoiceEffectiveStatus } from "@common/helpers/accrual-source";
import { Invoice, InvoiceStatus } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { InvoiceStatus as InvoiceStatusComponent } from "../../../InvoiceStatus";

export const StatusCell = memo(
    ({
        row,
        getValue,
    }: CellContext<ViewTableFeatures, Invoice, InvoiceStatus | null>) => {
        const status = getValue() ?? getInvoiceEffectiveStatus(row.original);

        return (
            <ViewTableCell>
                {status ? <InvoiceStatusComponent status={status} /> : null}
            </ViewTableCell>
        );
    },
);
